export const FETCH_BUILDER_LIST_SUCCESSS = "FETCH_BUILDER_LIST_SUCCESSS";
export const POST_BUILDER_SUCCESS = "POST_BUILDER_SUCCESS";
